import { CreatorLocationDetail } from './types';

export const getLocationFriendlyName = (location: CreatorLocationDetail) => {
  if (!location && typeof location !== 'object') return null;

  const { city, regionName, country } = location || {};
  return [city, regionName, country].filter(Boolean).join(', ');
};
